import { RobotTextResources } from "@portal/assets/text/RobotTextResources";
import { RiskLevel } from "@portal/types/robot/IRobotEnums";

export const GetRiskLevelName = (riskLevel: RiskLevel | undefined, isDefaultLanguage: boolean) => {
  if (!riskLevel) return "";

  const texts = isDefaultLanguage ? RobotTextResources.primary : RobotTextResources.secondary;
  const values = Object.values(RiskLevel);

  if (riskLevel === values[0]) return texts.PAGE_12_CAREFUL_TEXT;
  if (riskLevel === values[1]) return texts.PAGE_12_BALANCED_TEXT;
  if (riskLevel === values[2]) return texts.PAGE_12_OFFENSIVE_TEXT;
  if (riskLevel === values[3]) return texts.PAGE_12_EXTRA_OFFENSIVE_TEXT;
  return "";
};
